import React from 'react';
import ReactDOM from 'react-dom';

import FulcrumQuery from './components/fulcrum_query.js'

import '../node_modules/react-bootstrap-table/dist/react-bootstrap-table.min.css';

////////////////////////////////////////////////////////////////////

ReactDOM.render(
  <FulcrumQuery />,
  document.querySelector(".app")
);



// WEBPACK FOOTER //
// ./src/index.js